module.exports = __webpack_public_path__ + "img/partner-left-contact.9cbedbd3.png";